import React, { useEffect, useState,useRef } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';
import Hls from 'hls.js';

const siteIdToStreamMap = {
  'WA00005IS0009300SMAYTOWNS': '005vc09343',
  'WA00005IS002690OSCUSTSBRA': '005vc09343',
  // Add others...
};

const LocationDetail = () => {
  const { siteId } = useParams();
  const [site, setSite] = useState(null);
  const [error, setError] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const videoRef = useRef();

   useEffect(() => {
    api.get('/prediction/')
      .then((response) => {
        const matched = response.data.find((item) => item.siteId === siteId);
        if (matched) {
          setSite(matched);
        } else {
          setError('No matching site found.');
        }
      })
      .catch((err) => {
        console.error(err);
        setError('Error fetching site data.');
      });
  }, [siteId]);
  
useEffect(() => {
   if (!siteId) return;

  const streamId = siteIdToStreamMap[siteId] || '005vc09343';
  const streamUrl = `https://cdn3.wowza.com/5/V1VtUjlPejA1MWlh/live/${streamId}.stream/playlist.m3u8`;
  if (Hls.isSupported()) {
    const hls = new Hls();

    console.log('Attempting to load stream...');
	hls.loadSource(streamUrl);
    hls.attachMedia(videoRef.current);

    hls.on(Hls.Events.MANIFEST_PARSED, () => {
      console.log('HLS manifest parsed successfully.');
      videoRef.current.play();
    });

    hls.on(Hls.Events.ERROR, function (event, data) {
      console.error('HLS.js error:', data);
    });

    return () => hls.destroy();
  } else if (videoRef.current?.canPlayType('application/vnd.apple.mpegurl')) {
    console.log('Native HLS supported, setting src directly');
    videoRef.current.src = streamUrl;
  }
}, [siteId]);

  if (error) return <div style={{ padding: '1rem', color: 'red' }}>{error}</div>;
  if (!site) return <div style={{ padding: '1rem' }}>Loading...</div>;

  return (
    <div style={{ padding: '2rem' }}>
      <h1>{site.siteName}</h1>
      <p><strong>Site ID:</strong> {site.siteId}</p>

      <img
		  src={`/assets/${siteId}.png`}
		  alt={`Site ${siteId}`}
		  style={{
			width: '800px',      // 👈 Set a max width
			height: 'auto',
			border: '1px solid #ccc',
			borderRadius: '8px',
			marginBottom: '1rem'
		  }}
		  onError={(e) => {
			e.target.onerror = null;
			e.target.src = '/assets/not-found.png';
		  }}
		/>

      <p><strong>Reported Available:</strong> {site.reportedAvailable ?? 'N/A'}</p>
      <p><strong>Capacity:</strong> {site.capacity ?? 'N/A'}</p>
      <p><strong>Trust Data:</strong> {site.trustData ?? 'N/A'}</p>

      <h2>Prediction (Accuracy)</h2>
      <ul>
        {[
          { label: '10m', pre: site.pre_10m, acc: site.acc_10m },
          { label: '30m', pre: site.pre_30m, acc: site.acc_30m },
          { label: '1h', pre: site.pre_1h, acc: site.acc_1h },
          { label: '2h', pre: site.pre_2h, acc: site.acc_2h },
          { label: '3h', pre: site.pre_3h, acc: site.acc_3h },
          { label: '4h', pre: site.pre_4h, acc: site.acc_4h },
          { label: '6h', pre: site.pre_6h, acc: site.acc_6h },
          { label: '8h', pre: site.pre_8h, acc: site.acc_8h },
        ].map((item) => (
          <li key={item.label}>
            {item.label}: {item.pre ?? 'N/A'}{' '}
            <span style={{ color: '#808080' }}>
              ({item.acc != null ? `${item.acc.toFixed(2)}%` : 'N/A'})
            </span>
          </li>
        ))}
      </ul>

      <p><strong>Last Update:</strong> {site.timeRequest
        ? new Date(site.timeRequest).toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
          })
        : 'N/A'}</p>
		
		<div style={{ maxWidth: '800px', margin: '2rem auto' }}>
        <video
          ref={videoRef}
          controls
          style={{ width: '100%', borderRadius: '8px', border: '1px solid #ccc' }}
        />
      </div>


      <br />
      <a href="/" style={{ textDecoration: 'underline', color: 'blue' }}>
        ← Back to Map
      </a>
    </div>
  );
};

export default LocationDetail;
